import styled from 'styled-components';

export const ComplaintPopupStyles = styled.div`
  font-size: ${({ theme }) => theme.fontSize.nm};

  .title {
    font-size: 26px;
    font-weight: normal;
    margin: 0 0 16px 0;
    padding-right: 30px;
    color: #39444f;
  }

  .go-back {
    display: inline-flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #8c969d;
    cursor: pointer;

    &:hover {
      color: inherit;
    }

    .icon-arrow {
      margin: 0 6px 2px 0;
    }
  }

  .content {
    max-width: 450px;
  }

  button {
    cursor: pointer;
  }
`;

export const RadioButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  .radiobutton {
    margin-bottom: 10px;
  }
`;

export const SuccessText = styled.div`
  padding-top: 10px;
  color: ${({ theme }) => theme.colors.color_green};
`;

export const ErrorText = styled.div`
  padding-top: 10px;
  color: ${({ theme }) => theme.colors.color_red};
`;
